import { StandardEvents } from '@shopify/events';

const SELECTORS = ['.hygeon-ve-tier-info', '.hygeon-stock-status'];

document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;

  event.promise
    .then(({ detail }) => {
      const html = detail?.html;
      if (!html) return;
      for (const selector of SELECTORS) {
        const current = document.querySelector(selector);
        const next = html.querySelector(selector);
        if (current && next) current.replaceWith(next);
      }
    })
    .catch(() => {});
});
